export const AFTER_CONFERENCE_REPORT = "acr";
export const AFTER_CONFERENCE_EMAIL = "acrEmail";
export const ACTIVE = "active";
export const ALLOW_CONFERENCE_PROJECTCODE = "allowConfProjectCode";
export const ALLOW_HOST_MUTE_OVERRIDE = "allowHostMuteOverride";
export const BILLING_GROUP = "billingGroup";
export const CALL_FLOW = "callFlow";
export const CHAIR_DISCONNECT = "chairDisconnect";
export const CHANGE_DATE = "changeDate";
export const CHANGED_BY = "changedBy";
export const COMMENT = "comment";
export const CONFERENCE_LEVEL_PASSCODE = "confLevelPasscode";
export const CONFERENCE_PARTY_ACTION_TIMER = "confPartyActionTimer";
export const CONFERENCE_PARTY_ALERT_ACTION = "confPartyAlertAction";
export const CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT = "confPartyAlertActionWarningPrompt";
export const CONFERENCE_PARTY_ALERT_ALLOW_RESET = "confPartyAlertAllowReset";
export const CONFERENCE_PARTY_ALERT_THRESHOLD = "confPartyAlertThreshold";
export const CONFERENCE_PARTY_ALERT_TIMER = "confPartyAlertTimer";
export const CONFERENCE_QUICK_START = "confQuickStart";
export const CONFERENCE_ID = "conferenceId";
export const CONFERENCE_NAME = "conferenceName";
export const CONFERENCE_ROOM_ID = "conferenceRoomId";
export const CONFERENCE_TYPE = "conferenceType";
export const CONTRACT_NUMBER = "contractNo";
export const CREATED_BY = "createdBy";
export const CUSTOM_NAME = "customName";
export const DEACTIVASION_REASON = "deactivationReason";
export const DEBITOR = "debitor";
export const DIALOUT_MODE = "dialoutmode";
export const DOUBLE_PASSCODE_ENTRY = "doublePasscodeEntry";
export const FIRST_PARTY_ON_HOLD = "firstPartyOnHold";
export const FORCE_PROMPT_CAS_DIALOUTS = "forcePromptCasDialouts";
export const GUEST_CUSTOM_CONFIRM_MESSAGE = "guestCustomConfirmMessage";
export const GUEST_ENTRANCE_TONE = "guestEntranceTone";
export const GUEST_EXIT_TONE = "guestExitTone";
export const GUEST_PASSCODE = "guestPasscode";
export const GUEST_TALK_MODE = "guestTalkMode";
export const HOST_CUSTOM_CONFIRM_MESSAGE = "hostCustomConfirmMessage";
export const HOST_ENTRANCE_TONE = "hostEntranceTone";
export const HOST_EXIT_TONE = "hostExitTone";
export const HOST_PASSCODE = "hostPasscode";
export const HOST_TALK_MODE = "hostTalkMode";
export const HOST_CODE_LENGTH = "hostcodeLength";
export const GUEST_CODE_LENGTH = "guestcodeLength";
export const INTERNAL_MASTER_ID = "internalMasterId";
export const LANGUAGE = "language";
export const LAST_USED = "lastUsed";
export const MAX_PARTICIPANTS = "maxParticipants";
export const MUSICSOURCE = "musicSource";
export const ONE_TIME = "oneTime";
export const OWNER = "owner";
export const OWNER_EMAIL = "ownerEmail";
export const PARTICIPANT_NAME_RECORD = "participantNameRecordingFlag";
export const PASSCODE_RELOAD_INTERVAL = "passcodeReloadInterval";
export const PASSWORD_VALID_WITH_COUNT = "passwordValidWithCount";
export const PLAY_FIRST_CALLER_MESSAGE = "playFirstCallerMessage";
export const PREPAID_FLAG = "prepaidFlag";
export const PREPAID_SECONDS = "prepaidSeconds";
export const PRODUCT = "product";
export const RECORD_CODE = "recordCode";
export const RECORD_CONFERENCE = "recordConference";
export const SALES_PERSON = "salesPerson";
export const SCHEDULED_DURATION = "scheduledDuration";
export const SUB_CONFERENCE_ENABLED = "subConferenceEnabled";
export const TEMPLATE_ID = "templateId";
export const UNATTENDED_DIALOUT_ALLOWED = "unattendedDialoutAllowed";
export const UNATTENDED_DIALOUT_GUEST_ALLOWED = "unattendedDialoutGuestAllowed";
export const VALID = "valid";
export const WEB_PRESENTER = "webPresenter";
export const SCHEDULED_DATE = "scheduledDate";
export const ALLOW_GUEST_MUTE_OVERRIDE = "allowGuestMuteOverride";
export const PARAM_PRODUCT = "meetyoo_product";
export const PARAM_ONE_TIME = "meetyoo_oneTime";
export const PARAM_AFTER_CONFERENCE_REPORT = "meetyoo_acr";
export const PARAM_HOST_CODE_LENGTH = "meetyoo_hostcodeLength";
export const PARAM_GUEST_CODE_LENGTH = "meetyoo_guestcodeLength";
export const PARAM_CUSTOM_CONFIRM_MESSAGE = "customConfirmMessages";

export const SELECT_VALUES = [
  CONFERENCE_PARTY_ALERT_ACTION_WARNING_PROMPT,
  LANGUAGE,
  MUSICSOURCE,
  CONFERENCE_TYPE,
  CALL_FLOW,
  PARAM_PRODUCT,
  HOST_ENTRANCE_TONE,
  HOST_EXIT_TONE,
  GUEST_ENTRANCE_TONE,
  GUEST_EXIT_TONE,
  DOUBLE_PASSCODE_ENTRY,
  CONFERENCE_LEVEL_PASSCODE,
  PARAM_ONE_TIME,
  RECORD_CONFERENCE,
  CONFERENCE_PARTY_ALERT_ACTION,
  PREPAID_FLAG,
  PARAM_AFTER_CONFERENCE_REPORT,
  ALLOW_CONFERENCE_PROJECTCODE,
  CONFERENCE_QUICK_START,
  UNATTENDED_DIALOUT_ALLOWED,
  PARAM_HOST_CODE_LENGTH,
  PARAM_GUEST_CODE_LENGTH,
];
